// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1Rjk2","content":"ManualTimeModal_content__34-KY"};